var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src.length)?_c('figure',{staticClass:"page-image",class:{'is-sticky': _vm.sticky}},[_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }